module.exports = {
  // Error code returned by the users-profiles createUser mutation.
  DUPLICATE_DISPLAY_NAME: 'DUPLICATE_DISPLAY_NAME',
  // Set in the auth0 rule "Send verification email".
  EMAIL_NOT_VERIFIED: 'EMAIL_NOT_VERIFIED'
};
